<template>
    <div>
        <v-row>
            <v-col md="12" class="">
                <v-checkbox
                        v-model="dll"
                        :label="`DLL / Command line  Support`"
                        :disabled="secure_programming"
                ></v-checkbox>
                <v-checkbox
                        v-model="secure_programming"
                        :label="`Secure Programming`"
                ></v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "AddOptions",
        props: ['is_devices_page', 'setDLL', 'dll', 'secure_programming','change_row','setSecureProgramming'],
        watch: {
            dll(newValue) {
                this.setDLL(newValue);
                this.change_row();
            },
            secure_programming(newValue) {
                this.setSecureProgramming(newValue);
                if (newValue) {
                    this.setDLL(1);
                }
                this.change_row();

            }
        },
        methods: {
            dllSelected() {
                this.setDLL(this.dll)
            }
        }
    }
</script>

<style scoped>

</style>